import { Stack } from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";
import { withFetch } from "@ui-components/data-fetcher/DataFetcher.tsx";
import { DropdownField } from "@ui-components/form/DropdownField.tsx";
import { Fieldset } from "@ui-components/form/Fieldset/Fieldset.tsx";
import { StaticTagPickerField } from "@ui-components/form/StaticTagPickerField.tsx";
import { TextInputField } from "@ui-components/form/TextInputField.tsx";

import { quickAddContactFormNameOf } from "./QuickAddContactFormValues.tsx";

const QuickAddOrgContactFormFieldsBase: React.FunctionComponent = () => {
  const { core, practice } = useStores();

  const { countries, australianStates } = core.ref;

  const countryCode = core.tenantDetails?.country;

  return (
    <Stack
      tokens={{ childrenGap: 8 }}
      styles={{ root: { position: "relative", width: "100%" } }}
    >
      <TextInputField
        autoFocus
        name={quickAddContactFormNameOf("organisationName")}
        label="Name"
        required={true}
      />
      <StaticTagPickerField
        fetchDataSource={() =>
          practice.ref.organisationCategories.keyNameValues
        }
        excludeSelectedItems
        label="Categories"
        name={quickAddContactFormNameOf("organisationCategories")}
        styles={{
          text: { flexGrow: 0 }
        }}
        required
      />
      <Fieldset horizontal>
        <TextInputField
          label="Suburb"
          name={quickAddContactFormNameOf("suburb")}
        />
        {countryCode &&
        countries.values.some(
          c => c.code === countryCode && c.isStateRequired
        ) ? (
          <DropdownField
            name={quickAddContactFormNameOf("state")}
            label="State"
            styles={{ root: { width: "50%" } }}
            options={australianStates.keyTextValues}
          />
        ) : (
          <TextInputField
            label="City"
            name={quickAddContactFormNameOf("city")}
          />
        )}
        <TextInputField
          label="Postcode"
          name={quickAddContactFormNameOf("postCode")}
          styles={{ root: { width: "60%" } }}
        />
      </Fieldset>
      <TextInputField name={quickAddContactFormNameOf("phone")} label="Phone" />
    </Stack>
  );
};

export const QuickAddOrgContactFormFields = withFetch(
  x => [
    x.practice.ref.organisationCategories.load(),
    x.core.ref.australianStates.load()
  ],
  QuickAddOrgContactFormFieldsBase
);
